import { fromJS } from 'immutable'

//Action types
const SHOW_MAIN_MENU = 'UI/SHOW_MAIN_MENU'
const FILTER_DELIVERED_ORDERS = 'UI/FILTER_DELIVERED_ORDERS'
const SET_DAILY_REPORT_DATE = 'UI/SET_DAILY_REPORT_DATE'
const SET_DAILY_REPORT_PRODUCT = 'UI/SET_DAILY_REPORT_PRODUCT'
const SET_DAILY_REPORT_VARIATION = 'UI/SET_DAILY_REPORT_VARIATION'
//Action creators
export const showMainMenu = (value) => ({type: SHOW_MAIN_MENU, value})
export const setDailyReportDate = (value) => ({type: SET_DAILY_REPORT_DATE, value})
export const setDailyReportProduct = (value) => ({type: SET_DAILY_REPORT_PRODUCT, value})
export const setDailyReportVariation = (value) => ({type: SET_DAILY_REPORT_VARIATION, value})
export const filterDeliveredOrderLines = (value) => ({type: FILTER_DELIVERED_ORDERS, value})

//initial state for this reducer
const initialState = fromJS({
  showMainMenu: false,
  showUndeliveredOrderLines: true,
})
//Reducer
export default function reducer (state = initialState, action) {
  switch (action.type) {
    case SHOW_MAIN_MENU:
      return state.set('showMainMenu', action.value)
    case SET_DAILY_REPORT_DATE:
      return state.set('dailyReportDate', action.value)
    case SET_DAILY_REPORT_PRODUCT:
      return state.set('dailyReportProduct', action.value)
    case SET_DAILY_REPORT_VARIATION:
      return state.set('dailyReportVariation', action.value)
    case FILTER_DELIVERED_ORDERS:
      console.log(FILTER_DELIVERED_ORDERS, action.value)
      return state.set('showUndeliveredOrderLines', action.value)
    default:
      return state
  }
}




// WEBPACK FOOTER //
// ./src/redux/modules/uiDuck.js